import * as actionType from "./constants";

const initialState = {
    getTopNColorDataResponse: null,
    updateTopNColorResponse: null,
    addTopNColorResponse: null,
    deleteTopNColorResponse: null
};

const reducers = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_TOPN_COLOR_REQUEST:
            return {
                ...state,
                getTopNColorDataResponse: { isLoading: true }
            };
        case actionType.GET_TOPN_COLOR_SUCCESS:
            return {
                ...state,
                getTopNColorDataResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_TOPN_COLOR_FAILURE:
            return {
                ...state,
                getTopNColorDataResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.UPDATE_TOPN_COLOR_REQUEST:
            return {
                ...state,
                updateTopNColorResponse: { isLoading: true }
            };
        case actionType.UPDATE_TOPN_COLOR_SUCCESS:
            return {
                ...state,
                updateTopNColorResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.UPDATE_TOPN_COLOR_FAILURE:
            return {
                ...state,
                updateTopNColorResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.ADD_TOPN_COLOR_REQUEST:
            return {
                ...state,
                addTopNColorResponse: { isLoading: true }
            };
        case actionType.ADD_TOPN_COLOR_SUCCESS:
            return {
                ...state,
                addTopNColorResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.ADD_TOPN_COLOR_FAILURE:
            return {
                ...state,
                addTopNColorResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.DELETE_TOPN_COLOR_REQUEST:
            return {
                ...state,
                deleteTopNColorResponse: { isLoading: true }
            };
        case actionType.DELETE_TOPN_COLOR_SUCCESS:
            return {
                ...state,
                deleteTopNColorResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.DELETE_TOPN_COLOR_FAILURE:
            return {
                ...state,
                deleteTopNColorResponse: { isLoading: false, success: false, ...action.error }
            };

        default:
            return state;
    }
};
export default reducers;
